webpackJsonp([187651030027472],{

/***/ 408:
/***/ (function(module, exports) {

	module.exports = {"data":{"markdownRemark":{"html":"<p>Testing for Facebook's IFTTT applet.</p>","frontmatter":{"categories":["General Updates"],"date":"June 07, 2017","featuredImage":"placeholder.png","title":"Barclays has fixed Windows 10 - Creators Update app issues"}}},"pathContext":{"slug":"/facebook-ifttt-test/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---post-facebook-ifttt-test-f7fd8340a006267892ad.js